module.exports = __webpack_public_path__ + "img/1.a1bca13c.jpg";